import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { MapSettingsDTO, PatchMapSettingsInput } from '@warplan/shared';
import { api } from './api-client.js';

export const MAP_SETTINGS_QUERY_KEY = ['map-settings'] as const;

export function useMapSettings() {
  return useQuery({
    queryKey: MAP_SETTINGS_QUERY_KEY,
    queryFn: () => api.get<MapSettingsDTO>('/api/map-settings'),
    staleTime: 60_000,
  });
}

export function useUpdateMapSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (patch: PatchMapSettingsInput) =>
      api.patch<MapSettingsDTO>('/api/map-settings', patch),
    onMutate: async (patch) => {
      await qc.cancelQueries({ queryKey: MAP_SETTINGS_QUERY_KEY });
      const previous = qc.getQueryData<MapSettingsDTO>(MAP_SETTINGS_QUERY_KEY);
      if (previous) {
        const next: MapSettingsDTO = { ...previous };
        if (patch.disabledRegionKeys !== undefined) {
          next.disabledRegionKeys = patch.disabledRegionKeys;
        }
        qc.setQueryData<MapSettingsDTO>(MAP_SETTINGS_QUERY_KEY, next);
      }
      return { previous };
    },
    onError: (_err, _vars, ctx) => {
      if (ctx?.previous) qc.setQueryData(MAP_SETTINGS_QUERY_KEY, ctx.previous);
    },
    onSuccess: (updated) => {
      qc.setQueryData<MapSettingsDTO>(MAP_SETTINGS_QUERY_KEY, updated);
    },
  });
}
